import { defaultBackground, defaultBorder, defaultButton, defaultColors } from '../../../styles/style-guide';

export const colorTypes: Record<number, keyof typeof defaultColors> = {
  1: 'primary',
  2: 'secondary',
  3: 'white',
};

export const borderTypes: Record<number, keyof typeof defaultBorder> = {
  1: 'primary',
  2: 'secondary',
  3: 'third',
  4: 'hover'
};

export const buttonTypes: Record<number, keyof typeof defaultButton> = {
  1: 'primary',
  2: 'secondary',
  3: 'third'
};

export const backgroundTypes: Record<number, keyof typeof defaultBackground> = {
  1: 'primary',
  2: 'secondary',
  3: 'third',
  4: 'hover'
};
